var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import closeIcon from "../assets/icons/close.svg";
// import toast from "react-hot-toast";
import toast from "react-hot-toast";
import { getPricing } from "../utils/uploadPricingSheet";
import { testConfigurations } from "../const/testConfigurations";
export default function TestPricingForm({ show, closeForm, }) {
    const [isLoading, setIsLoading] = useState(false);
    const [price, setPrice] = useState([]);
    useEffect(() => {
        if (show) {
            const fetchPrice = (config) => __awaiter(this, void 0, void 0, function* () {
                setIsLoading(true);
                try {
                    const res = yield getPricing(config);
                    price.push(res);
                }
                catch (error) {
                    toast.error("Unable to get pricing");
                }
                setIsLoading(false);
            });
            const fetchAllPrices = () => __awaiter(this, void 0, void 0, function* () {
                for (let i = 0; i < testConfigurations.length; i++) {
                    yield fetchPrice(testConfigurations[i].config);
                }
            });
            fetchAllPrices();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);
    return (_jsx("div", { children: _jsx(Modal, Object.assign({ show: show, onClose: () => null, type: "pricing" }, { children: _jsxs("form", Object.assign({ 
                //   onSubmit={}
                className: "p-2 w-96 flex flex-col overflow-y-scroll", style: { maxHeight: "85vh", width: "60vw", maxWidth: "700px" } }, { children: [_jsx("div", Object.assign({ className: "flex mb-4" }, { children: _jsx("img", { className: "ml-auto cursor-pointer", onClick: () => {
                                if (!isLoading) {
                                    closeForm();
                                    setPrice([]);
                                }
                            }, src: closeIcon, alt: "close" }) })), _jsxs("div", Object.assign({ className: "flex font-bold justify-between border-b mb-2" }, { children: [_jsx("p", Object.assign({ className: "mb-2 text-lg ml-5" }, { children: "Configuration" })), _jsx("p", Object.assign({ className: "mb-2 text-lg mr-5" }, { children: "Price " }))] })), (price === null || price === void 0 ? void 0 : price.length) >= testConfigurations.length ? (testConfigurations.map((config, index) => {
                        return (_jsxs("div", Object.assign({ className: "flex justify-between" }, { children: [_jsxs("p", Object.assign({ className: "mb-2 text-lg" }, { children: [config.name, " "] })), _jsxs("p", Object.assign({ className: "mb-2 text-lg" }, { children: ["INR ", price[index], " "] }))] }), index));
                    })) : (_jsx("p", Object.assign({ className: "font-bold text-lg text-center" }, { children: "Loading..." })))] })) })) }));
}
